import { LoggerParamMetadata, PROPERTY_KEY_LOG_VALUES } from "./paramMetadata";

/**
 * Flags this parameter so the @LogInvocation decorator knows to log this parameter's name instead of it's value.
 */

export function LogName(name: string): ParameterDecorator
{
	return propertyDescriptor as ParameterDecorator;

	function propertyDescriptor(target: Object, methodName: string | symbol, index: number): void
	{
		const _methodName = methodName || "ctor";
		const existingLogValues: Array<LoggerParamMetadata> = Reflect.getOwnMetadata(PROPERTY_KEY_LOG_VALUES, target, _methodName) || [];

		const metadata = existingLogValues[index] || (existingLogValues[index] = {});
		metadata.name = name;

		Reflect.defineMetadata(PROPERTY_KEY_LOG_VALUES, existingLogValues, target, _methodName);
	}
}
